export function scrollToElement(element, offset= -150) {
	if(!element) return
	//const elementTop = element.getBoundingClientRect().top;
	const top = element.getBoundingClientRect().top + window.pageYOffset + offset;
	window.scrollTo({
		top: top,
		behavior: 'smooth'
	});
	
}